import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import TableFooter from "@/components/table/footer";
import TablePagination from "@/components/table/pagination";
import { exportToCSV } from "@/utils/export-to-csv";
import { Box } from "rizzui";
import { categoryListColumns } from "./columns";
import Filters from "./filters";
import { Category } from "@/types";
import { useEffect } from "react";

type CategoryListTableProps = {
    categories: Category[];
    refresh(): void;
};

export default function CategoryListTable({ categories, refresh }: CategoryListTableProps) {
    const { table, setData } = useTanStackTable<Category>({
        tableData: categories,
        columnConfig: categoryListColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 10,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                    table.resetRowSelection();
                },
                handleMultipleDelete: (rows) => {
                    setData((prev) => prev.filter((r) => !rows.includes(r)));
                    table.resetRowSelection();
                },
            },
            enableColumnResizing: false,
        },
    });

    useEffect(() => {
        setData(categories);
    }, [categories, setData]);

    const selectedData = table
        .getSelectedRowModel()
        .rows.map((row) => row.original);

    function handleExportData() {
        exportToCSV(
            selectedData,
            "Id,Name,Description",
            `Categories_${selectedData.length}`,
        );
    }

    return (
        <Box>
            {/* <Filters table={table} /> */}
            <Table
                table={table}
                variant="modern"
                classNames={{
                    container: "border border-muted rounded-md",
                    rowClassName: "last:border-0",
                }}
            />
            <TableFooter table={table} onExport={handleExportData} />
            <TablePagination table={table} className="py-4" />
        </Box>
    );
}
